// NATIVE 


// INSTALLED 

// CUSTOM 
import { AxiosAdapter } from "../commons/adapters";

const http = new AxiosAdapter();


export const uploadFilePdfService =  async(code_file:string, file:string, setPercentageUploadRut:any) => {

    let formData:any = new FormData();

    formData.append('code_file', code_file);
    formData.append('file', file);
    
    return await http.post<any>('/v1/upload-pdf', formData, setPercentageUploadRut); 
}



export const uploadFileImageService =  async(code_file:string, file:string, setPercentageUploadRut:any) => {

    let formData:any = new FormData();

    formData.append('code_file', code_file);
    formData.append('file', file);
    
    return await http.post<any>('/v1/upload-images', formData, setPercentageUploadRut); 
}



export const uploadFileImageFromCameraService =  async(code_file:string, blob:string, setPercentageUploadRut:any) => {

    let formData:any = new FormData();

    formData.append('code_file', code_file);
    formData.append('file', blob);
    
    
    return await http.post<any>('/v1/upload-images', formData, setPercentageUploadRut); 
}


export const updateAvatarEmployeeService =  async(code_file: string, idEmployee:string, blob:string, setPercentageUploadRut:any) => {

    let formData:any = new FormData();

    formData.append('code_file', code_file);
    formData.append('idEmployee', idEmployee);
    formData.append('file', blob);
    
    
    return await http.post<any>('/v1/upload-images/update-employee-avatar', formData, setPercentageUploadRut); 
}


export const changeAvatarService = async(code_file: string, file: File) => {
    let formData: any = new FormData();
    formData.append('code_file', code_file);
    formData.append('file', file);
    
    return await http.postLogin<any>('/v1/users/change-avatar', formData);
}
